<template>
  <v-layout row wrap justify-center>
    <v-container row wrap fluid>
      <v-layout row wrap fluid>
        <v-subheader>
          <h4 class="primary--text">
            <strong>GESTIONE</strong>
          </h4>
        </v-subheader>
        <v-flex xs12 ma-0 pa-0 md1 class="px-1">
          <v-select v-model="tipoRinnovo" :items="['Rinnovi'/*, 'Tesserati'*/]" @change="aggiorna()" style="margin: 0px; padding: 0px;"></v-select>
        </v-flex>
        <v-flex hidden-sm-and-down>
          <v-spacer></v-spacer>
        </v-flex>
        <v-btn
          slot="activator"
          v-if="selected.length && checkFunzione(elencoFunzioni.ACCETTA_RINNOVI_ISCRIZIONI) && tipoRinnovo == 'Rinnovi'"
          @click="openDialogAnnullamento()"
          class="btnDefault"
          small
          color="purple lighten-2 white--text"
          dark
        >
          <v-icon small>undo</v-icon>{{ tipoRinnovo == 'Rinnovi' ? 'Elimina rinnovi' : 'elimina Tesserati' }}
        </v-btn>
        <associato-filtri></associato-filtri>
        <v-btn slot="activator" v-if="tipoRinnovo == 'Rinnovi'" @click="openDialogGtWeb()" class="btnDefault" small color="accent white--text" dark>
          <v-icon small class="hidden-sm-and-down mr-1">import_export</v-icon>{{ tipoRinnovo == 'Rinnovi' ? 'Esporta rinnovati' : 'Esporta tesserati' }}
        </v-btn>
        <v-btn @click="dialogDuplicatiOpen()" class="btnDefault" small color="accent white--text"> <v-icon small left color="white">import_export</v-icon>export duplicati </v-btn>
        <v-btn slot="activator" @click="dialogRinnoviOpen()" style="text-xs-center" class="btnDefault" small color="orange white--text" dark>
          <v-icon small class="mr-1">cloud_upload</v-icon> {{ tipoRinnovo == 'Rinnovi' ? 'Importa rinnovati' : 'Importa tesserati' }}
        </v-btn>
        <v-btn @click="aggiorna()" class="btnDefault" small color="primary white--text"> <v-icon small left color="white">cached</v-icon>Aggiorna </v-btn>
      </v-layout>
    </v-container>

    <v-container fluid>
      <v-layout row class="text-xs-center">
        <v-flex v-if="tipoRinnovo == 'Rinnovi'" xs12>
          <h4 class="primary--text">
            <strong>GESTIONE RINNOVI PER L'ANNO {{ annoRinnovo }}</strong>
          </h4>
        </v-flex>
        <v-flex v-if="tipoRinnovo == 'Tesserati'" xs12>
          <h4 class="primary--text">
            <strong>GESTIONE TESSERATI PER L'ANNO CORRENTE</strong>
          </h4>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-4 mb-3">
        <v-icon left class="hidden-sm-and-down mr-3">search</v-icon>
        <v-flex xs12 md1 mt-2 class="px-1">
          <v-text-field v-model="filtraTessere" box label="N° Pass" clearable hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 md3 mt-2 class="px-1">
          <v-autocomplete
            v-model="filtraAssociazione"
            :items="associazioni"
            :return-object="false"
            item-text="Denominazione"
            item-value="id"
            box
            label="Sodalizio"
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md2 mt-2 class="px-1">
          <v-autocomplete
            v-model="filtraSezioni"
            :items="associatiFiltrati"
            :return-object="false"
            item-text="SezioneDescrizione"
            item-value="SezioneDescrizione"
            box
            label="Regione"
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
        <v-flex xs12 md2 mt-2 class="px-1">
          <v-text-field v-model="filtraTesto" box label="Cerca" clearable hide-details></v-text-field>
        </v-flex>

        <v-flex md3 xs12 mt-2 class="pt pl-3 text-xs-center">
          <v-btn-toggle v-model="filtraStato" :class="isMobile ? 'v-btn-toggle-vert' : 'v-btn-toggle-horiz'" flat mandatory>
            <v-btn flat value="Tutti" color="black">Tutti</v-btn>
            <v-btn flat value="Inseriti" color="brown">Nuovi Iscritti</v-btn>
            <v-btn flat value="Rinnovati" color="purple lighten-2">Rinnovati</v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>

      <v-layout column>
        <v-data-table
          v-model="selected"
          :headers="tipoRinnovo === 'Rinnovi' ? headersRinovi : headersTesserati"
          :items="associatiFiltrati"
          :search="filtraTesto"
          :pagination.sync="pagination"
          :custom-sort="customSort"
          :hide-headers="isMobile"
          :class="{ mobile: isMobile }"
          :select-all="tipoRinnovo === 'Rinnovi' ? true : false"
          disable-initial-sort
        >
          <template slot="items" v-if="props.item.isAttivo" slot-scope="props">
            <tr v-if="!isMobile" :active="props.selected" @click="selectRow(props)">
              <td v-if="checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS) && tipoRinnovo === 'Rinnovi'" :class="{ 'red lighten-5': !props.item.isAttivo }">
                <v-checkbox v-model="props.selected" @click="props.selected = !props.selected" hide-details></v-checkbox>
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable text-xs-right">
                {{ props.item.TesseraCsain }}
              </td>
              <td class="clickable text-xs-right">{{ props.item.NumeroTessera }}</td>
              <td
                :class="{ 'red lighten-5': !props.item.isAttivo, 'orange--text': props.item.RichiestoRinnovo && canModifyAssociato(props.item.id, props.item.Associazione.id) }"
                bold
                class="clickable font-weight-bold"
              >
                {{ props.item.Denominazione }}
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable">{{ props.item.Associazione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" bold class="clickable">{{ props.item.SezioneDescrizione }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">{{ showDataAssociato(props.item) ? props.item.Email : '-' }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-right">{{ showDataAssociato(props.item) ? props.item.Telefono : '-' }}</td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable">
                {{ showDataAssociato(props.item) ? (props.item.CittaIndirizzo ? props.item.CittaIndirizzo : '') : '' }}
              </td>

              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-center">
                <v-tooltip v-if="props.item.StatoAnagrafica" top>
                  <v-avatar
                    slot="activator"
                    :size="15"
                    :class="{
                      'purple lighten-2': props.item.StatoAnagrafica == 'Rinnovata',
                      brown: props.item.StatoAnagrafica == 'Inserita',
                    }"
                  ></v-avatar>
                  <span>{{ props.item.StatoAnagrafica }}</span>
                </v-tooltip>
              </td>
              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="clickable text-xs-center">
                <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                  <span class="white--text xm">T</span>
                </v-avatar>
                <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                  <span class="white--text xm">I</span>
                </v-avatar>
                <v-avatar v-if="props.item.Open && !props.item.RichiestoPassGare" size="24" color="cyan" small>
                  <span class="white--text xm">O</span>
                </v-avatar>
                <v-avatar v-if="props.item.Open && props.item.RichiestoPassGare" size="24" color="green" small>
                  <span class="white--text xm">O</span>
                </v-avatar>
                <v-avatar v-if="props.item.Quadro && props.item.RuoloQuadro == 'PRESIDENTE'" size="24" color="purple" small>
                  <span class="white--text xm">P</span>
                </v-avatar>
              </td>

              <td :class="{ 'red lighten-5': !props.item.isAttivo }" class="text-xs-right">
                <v-tooltip v-if="tipoRinnovo == 'Rinnovi'" top>
                  <v-btn slot="activator" @click="editDatiRinnovo(props.item)" small outline icon class="ma-1 mr-0" color="orange">
                    <v-icon small color="orange">contacts</v-icon>
                  </v-btn>
                  <span>Dati Rinnovo</span>
                </v-tooltip>

                <v-tooltip v-if="canModifyAssociato(props.item.id, props.item.Associazione.id)" top>
                  <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                    <v-icon small color="primary">edit</v-icon>
                  </v-btn>
                  <span>Modifica Tesserato</span>
                </v-tooltip>
              </td>
            </tr>

            <tr v-else :active="props.selected" @click="props.selected = !props.selected" style="padding-bottom: 35px;">
              <td class="flex-td">
                <ul class="flex-content">
                  <li v-if="checkFunzione(elencoFunzioni.STAMPA_CSAIN_PASS) && tipoRinnovo == 'Rinnovi'" data-label="Sel" class="flex-item">
                    <v-checkbox v-if="props.item.isAttivo" v-model="props.selected" hide-details></v-checkbox>
                    <v-icon v-if="!props.item.isAttivo" color="red darken-3">remove_circle</v-icon>
                  </li>
                  <li data-label="Pass" class="flex-item">{{ props.item.NumeroTessera }}</li>
                  <li data-label="Tessera Csain" class="flex-item">{{ props.item.TesseraCsain }}</li>
                  <li
                    :class="{ 'orange--text': props.item.RichiestoRinnovo && canModifyAssociato(props.item.id, props.item.Associazione.id) }"
                    data-label="Denominazione"
                    bold
                    class="flex-item"
                  >
                    {{ props.item.Denominazione }}
                  </li>
                  <li data-label="Sodalizio" bold class="flex-item">{{ props.item.Associazione }}</li>
                  <li data-label="Regione" bold class="flex-item">{{ props.item.CittaIndirizzo }}</li>
                  <li data-label="Città" class="flex-item">
                    {{ showDataAssociato(props.item) ? (props.item.SezioneDescrizione ? props.item.SezioneDescrizione : '') : '' }}
                  </li>
                  <li data-label="Email" class="flex-item">{{ showDataAssociato(props.item) ? props.item.Email : '-' }}</li>
                  <li data-label="Telefono" class="flex-item">{{ showDataAssociato(props.item) ? props.item.Telefono : '-' }}</li>

                  <li data-label="Stato" class="flex-item">
                    <v-tooltip v-if="props.item.StatoAnagrafica" top>
                      <v-avatar
                        slot="activator"
                        :size="15"
                        :class="{
                          'purple lighten-2': props.item.StatoAnagrafica == 'Rinnovata',
                          brown: props.item.StatoAnagrafica == 'Inserita',
                        }"
                      ></v-avatar>
                      <span>{{ props.item.StatoAnagrafica }}</span>
                    </v-tooltip>
                  </li>
                  <li :class="!props.item.isAttivo" data-label="Tipo" class="flex-item">
                    <v-avatar v-if="props.item.Tecnico" size="24" color="blue" small>
                      <span class="white--text xm">T</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Istruttore" size="24" color="red" small>
                      <span class="white--text xm">I</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Open && !props.item.RichiestoPassGare" size="24" color="cyan" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Open && props.item.RichiestoPassGare" size="24" color="green" small>
                      <span class="white--text xm">O</span>
                    </v-avatar>
                    <v-avatar v-if="props.item.Quadro && props.item.RuoloQuadro == 'PRESIDENTE'" size="24" color="purple" small>
                      <span class="white--text xm">P</span>
                    </v-avatar>
                  </li>

                  <li data-label="Azioni" class="flex-row">
                    <v-tooltip v-if="canModifyAssociato(props.item.id, props.item.Associazione.id)" top>
                      <v-btn slot="activator" @click="editItem(props.item)" small outline icon class="ma-1 mr-0" color="primary">
                        <v-icon small color="primary">edit</v-icon>
                      </v-btn>
                      <span>Modifica Tesserato</span>
                    </v-tooltip>

                    <v-tooltip v-if="tipoRinnovo == 'Rinnovi'" top>
                      <v-btn slot="activator" @click="editDatiRinnovo(props.item)" small outline icon class="ma-1 mr-0" color="orange">
                        <v-icon small color="orange">contacts</v-icon>
                      </v-btn>
                      <span>Dati Rinnovo</span>
                    </v-tooltip>
                  </li>
                </ul>
              </td>
            </tr>
          </template>
          <template slot="no-results">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <template slot="no-data">
            <v-alert :value="true" color="error lighten-3" icon="warning" class="my-3">Nessun risultato</v-alert>
          </template>
          <!-- PAGINAZIONE IN TABELLA  -->
          <template slot="pageText" slot-scope="props">Risultati {{ props.pageStart }} - {{ props.pageStop }} di {{ props.itemsLength }}</template>
        </v-data-table>
      </v-layout>
    </v-container>

    <v-dialog v-model="dialogDuplicati" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">Esportazione associati duplicati </v-card-title>
        <v-card-text class="headline">Esportare i Rinnovati che sono stati inseriti con due codici fiscali differenti</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogDuplicati = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn @click="esportaDoppi()" color="accent white--text" dark> <v-icon small left>import_export</v-icon>Esporta associati duplicati </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogGtWeb" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold accent white--text">{{
          tipoRinnovo == 'Rinnovi' ? 'Esportazione arcieri rinnovati' : 'Esportazione arcieri tesserati'
        }}</v-card-title>
        <v-card-text class="headline">{{
          tipoRinnovo == 'Rinnovi' ? 'Verranno esportati tutte le anagrafiche di cui è stato inserito il rinnovo' : 'Verranno esportati tutte le anagrafiche dei tesserati'
        }}</v-card-text>
        <v-card-actions text-aligne-right>
          <v-spacer></v-spacer>
          <v-btn @click="dialogGtWeb = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>

          <v-btn @click="exportRinnovi()" color="accent white--text" dark>
            <v-icon small left>import_export</v-icon>{{ tipoRinnovo == 'Rinnovi' ? ' Esporta rinnovi' : 'Esporta tesserati' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAnnullamento" xs-6 persistent max-width="490">
      <v-card>
        <v-card-title class="display-1 font-weight-bold purple lighten-2 white--text">Eliminare la richiesta di rinnovo</v-card-title>
        <v-card-text class="headline">Attenzione, per gli arcieri selezionati verrà annullata la richiesta di rinnovo dell'iscrizione.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogAnnullamento = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
          <v-btn :disabled="isLoading" @click="annullaIscrizioni(selected)" color="purple lighten-2 white--text" dark>
            <v-icon small class="mr-1">delete</v-icon>Elimina richiesta
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogModificaRinnovo" persistent max-width="1000">
      <v-card>
        <v-card-title class="display-1 font-weight-bold orange white--text">Visualizza dati rinnovo</v-card-title>

        <storico-iscrizione-form :storico-iscrizione.sync="storicoIscrizione"></storico-iscrizione-form>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-flex style="text-align: end;">
            <v-btn @click="dialogModificaRinnovo = false" color="red white--text" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>
            <v-btn v-if="storicoIscrizione.StatoAnagrafica == 'Inserita'" :disabled="rinnovato" @click="aggiungiIscrizione(storicoIscrizione)" color="blue white--text" flat>
              <v-icon small class="mr-1">check</v-icon>iscrivi per anno corrente
            </v-btn>
            <v-btn @click="annullaIscrizione(storicoIscrizione)" color="purple lighten-2 white--text" dark> <v-icon small class="mr-1">delete</v-icon>Elimina richiesta </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogRinnovi" style="margin: auto;" persistent max-width="700">
      <v-card>
        <v-card-title class="display-1 font-weight-bold orange white--text"> {{ tipoRinnovo == 'Rinnovi' ? 'Importazione Rinnovati' : 'Importazione tesserati' }}</v-card-title>
        <v-card-text class="headline">{{ tipoRinnovo == 'Rinnovi' ? 'Importazione dei rinnovati in formato GTWEB' : 'Importazione dei tesserati in formato GTWEB' }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogRinnovi = false" color="red white--text" class="btnDefault" flat> <v-icon small class="mr-1">undo</v-icon>Annulla </v-btn>

          <v-btn slot="activator" :disabled="isLoading" @click="pickFile" color="orange white--text" class="btnDefault" dark>
            <v-icon small left>cloud_upload</v-icon> {{ tipoRinnovo == 'Rinnovi' ? 'Importa Rinnovati' : 'Importa tesserati' }}
          </v-btn>
          <input ref="fileRinnovo" @change="onFilePicked" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none;" />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Attendere caricamento rinnovo
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoadingDelete" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Attendere eliminazione richiesta rinnovo
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="errorDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Notifica Aggiornamento Anagrafica</span>
        </v-card-title>
        <v-card-text>
          <span v-html="errorMessage"></span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="errorDialog = false" color="green darken-1" flat="flat">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <associato-form
      :prop-elm-anagrafica.sync="associatoObj"
      :prop-image.sync="imageObj"
      :prop-form-mode.sync="formMode"
      :is-storico="true"
      @reset-elm="resetElm()"
    ></associato-form>
  </v-layout>
</template>

<script>
  import AssociatoForm from './AssociatoForm';
  import StoricoIscrizioneForm from './StoricoIscrizioneForm';
  import AssociatoFiltri from './AssociatoFiltri';
  import AssociatoEntity from './AssociatoEntity';
  import ImageEntity from '../generale/ImageEntity';
  import FileEntity from '../../eventi/generale/FileEntity';
  import { bus } from '@/main';
  import Util from '@/util';
  import Security from '@/security';
  import { mapGetters, mapActions, mapState } from 'vuex';
  import { callbackify } from 'util';

  export default {
    components: {
      AssociatoForm,
      AssociatoFiltri,
      StoricoIscrizioneForm,
    },
    data() {
      return {
        elencoFunzioni: Security.enFunzione,
        formModes: Util.enFormMode,
        formMode: Util.enFormMode.VISUALIZZAZIONE,
        rinnovoObj: new FileEntity(),
        rinnovato: false,
        tipoRinnovo: 'Rinnovi',
        switch1: true,
        dialog: false,
        dialogDuplicati: false,
        dialogModificaRinnovo: false,
        dialogAnnullamento: false,
        dialogGtWeb: false,
        dialogSagitta: false,
        dialogAttestato: false,
        dialogEliminato: false,
        dialogRinnovi: false,
        errorDialog: false,
        errorMessage: '',
        ruoli: Security.ruolo,
        filtraTesto: '',
        isMobile: false,
        isLoading: false,
        isLoadingDelete: false,
        filtroStorico: '',
        filtraTessere: '',
        filtraSezioni: '',
        filtraAssociazione: '',
        filtraStato: 'Tutti',
        attestatoSelected: null,
        rinnovoSelected: null,
        eliminatoSelected: null,
        selected: [],
        headersRinovi: [
          { text: 'Tessera Csain', sortable: true, value: 'TesseraCsain', width: '80px', align: 'right' },
          { text: 'Pass', sortable: true, value: 'NumeroTessera', width: '80px', align: 'right' },
          { text: 'Denominazione', sortable: true, value: 'Denominazione' },
          { text: 'Sodalizio', sortable: true, value: 'Associazione' },
          { text: 'Regione', sortable: true, value: 'SezioneDescrizione' },
          { text: 'Email', sortable: true, value: 'Email', align: 'right' },
          { text: 'Telefono', sortable: true, value: 'Telefono', align: 'right' },
          {
            text: 'Città',
            sortable: true,
            value: 'CittaIndirizzo',
          },
          { text: 'Stato', sortable: true, value: 'StatoAnagrafica', width: '70px', align: 'center' },
          { text: 'Tipo', sortable: false, value: '', width: '100px', align: 'center' },
          { text: 'Azioni', sortable: false, value: '', width: '140px', align: 'center' },
        ],
        headersTesserati: [
          { text: 'Tessera Csain', sortable: true, value: 'TesseraCsain', width: '80px', align: 'right' },
          { text: 'Pass', sortable: true, value: 'NumeroTessera', width: '80px', align: 'right' },
          { text: 'Denominazione', sortable: true, value: 'Denominazione' },
          { text: 'Sodalizio', sortable: true, value: 'Associazione' },
          { text: 'Regione', sortable: true, value: 'SezioneDescrizione' },
          { text: 'Email', sortable: true, value: 'Email', align: 'right' },
          { text: 'Telefono', sortable: true, value: 'Telefono', align: 'right' },
          {
            text: 'Città',
            sortable: true,
            value: 'CittaIndirizzo',
          },
          { text: 'Stato', sortable: true, value: 'StatoAnagrafica', width: '70px', align: 'center' },
          { text: 'Tipo', sortable: false, value: '', width: '100px', align: 'center' },
          { text: 'Azioni', sortable: false, value: '', width: '140px', align: 'center' },
        ],
        pagination: {
          rowsPerPage: 10,
        },
        associatoObj: new AssociatoEntity(),
        imageObj: new ImageEntity(),
        editedItem: {},
      };
    },
    computed: {
      ...mapGetters('associatiModule', ['getAssociati', 'getAssociato', 'getDettagliAssociazione', 'getImage', 'getStoricoIscrizione', 'getStoricoIscrizioni']),
      ...mapGetters('associazioniModule', ['getAssociazioni']),
      ...mapGetters(['isLogged', 'jwt']),
      ...mapGetters('sharedModule', ['getSezioni', 'getAnnoRinnovo']),
      ...mapGetters(['userData']),

      storicoIscrizione() {
        return this.getStoricoIscrizione;
      },

      associazioni() {
        return this.getAssociazioni;
      },

      annoRinnovo() {
        return this.getAnnoRinnovo;
      },

      calculatedRow() {
        return this.$vuetify.breakpoint.name;
      },
      image() {
        return this.getImage;
      },
      sezioni() {
        return this.getSezioni;
      },
      associati() {
        return this.getAssociati;
      },
      associato() {
        return this.getAssociato;
      },

      dettagliAssociazione() {
        return this.getDettagliAssociazione;
      },
      pages() {
        if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null) {
          return 0;
        }
        return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      },
      isAdmin() {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.UTENTE_AMMINISTRATIVO || this.userData.Role === this.ruoli.ADMIN;
        } else {
          return false;
        }
      },
      isResponsabile(id) {
        if (this.userData.Role) {
          return this.userData.Role === this.ruoli.RESPONSABILE_ASSOCIAZIONE && this.userData.associazioneId == id;
        } else {
          return false;
        }
      },

      associatiFiltrati() {
        // filtro in tempo reale
        let richiestatiList = null;
        if (this.$route.params.idAssociazione) {
          richiestatiList = this.associati.filter((a) => a.associazioneId == this.$route.params.idAssociazione);
        } else {
          if (this.userData.AssociazioneId) {
            richiestatiList = this.associati.filter((a) => a.associazioneId == this.userData.AssociazioneId);
          } else {
            if (this.filtraAssociazione) {
              richiestatiList = this.associati.filter((a) => a.associazioneId == this.filtraAssociazione);
            } else {
              richiestatiList = this.associati;
            }
          }
        }
        return richiestatiList.filter((i) => {
          if (!this.filtraSezioni && !this.filtraTessere && this.filtraStato == 'Tutti') {
            return true;
          } else if (this.filtraStato != 'Tutti' && !this.filtraTessere && !this.filtraSezioni) {
            switch (this.filtraStato) {
              case 'Rinnovati':
                return i.StatoAnagrafica == 'Rinnovata';
              case 'Inseriti':
                return i.StatoAnagrafica == 'Inserita';
              default:
                break;
            }
          }
          if (this.filtraTessere != '' && i.NumeroTessera && this.filtraStato == 'Tutti') {
            return i.NumeroTessera == this.filtraTessere;
          }
          if (this.filtraSezioni != '' && i.SezioneDescrizione && this.filtraStato == 'Tutti') {
            return i.SezioneDescrizione == this.filtraSezioni;
          } else {
            if (i.NumeroTessera && !this.filtraSezioni) {
              switch (this.filtraStato) {
                case 'Rinnovati':
                  return i.StatoAnagrafica == 'Rinnovata' && i.NumeroTessera == this.filtraTessere;
                case 'Inseriti':
                  return i.StatoAnagrafica == 'Inserita';
                default:
                  break;
              }
            }
            if (i.SezioneDescrizione && !this.filtraTessere) {
              switch (this.filtraStato) {
                case 'Inseriti':
                  return i.StatoAnagrafica == 'Inserita' && i.SezioneDescrizione == this.filtraSezioni;
                case 'Rinnovati':
                  return i.StatoAnagrafica == 'Rinnovata' && i.SezioneDescrizione == this.filtraSezioni;
                default:
                  break;
              }
            }
          }
          return false;
        });
      },
    },
    watch: {
      associato() {
        this.associatoObj = new AssociatoEntity(this.associato);
      },
      image() {
        this.imageObj = new ImageEntity(this.image);
      },
      fileRinnovo() {
        this.rinnovoObj = new FileEntity(this.fileRinnovo);
      },

      breakPoinSize() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
          case 'sm':
            this.isMobile = true;
            break;
          case 'md':
          case 'lg':
          case 'xl':
            this.isMobile = false;
            break;
        }
      },
      calculatedRow() {
        switch (this.$vuetify.breakpoint.name) {
          case 'sm':
          case 'xs':
            this.pagination.rowsPerPage = 10;
            this.isMobile = true;
            break;
          case 'md':
            this.pagination.rowsPerPage = 15;
            this.isMobile = false;
            break;
          case 'lg':
            this.pagination.rowsPerPage = 20;
            this.isMobile = false;
            break;
          case 'xl':
            this.pagination.rowsPerPage = 25;
            this.isMobile = false;
            break;
        }
      },
    },
    created() {
      const vm = this;
      vm.loadTipologie();
      vm.loadAnnoRinnovo();
      vm.loadAssociazioni();
      vm.loadDaRinnovare();

      switch (this.$vuetify.breakpoint.name) {
        case 'sm':
        case 'xs':
          this.isMobile = true;
          break;
        case 'md':
          this.isMobile = false;
          break;
        case 'lg':
          this.isMobile = false;
          break;
        case 'xl':
          this.isMobile = false;
          break;
      }

      // se value == false instanzia un'entity vuota e visualizza la modale
      bus.$on('associatoDialog', function (value) {
        vm.associatoDialog = value;
        if (!value) {
          vm.associatoObj = new AssociatoEntity();
          vm.associatoObj.Associazione = vm.dettagliAssociazione;
          vm.imageObj = new ImageEntity();
        }
      });

      bus.$on('deleteAssociati', function (value) {
        if (value) {
          setTimeout(function () {
            vm.loadDaRinnovare();
          }, 1000);
        }
      });

      //  vm.pagination.rowsPerPage = this.calculatedRow;

      if (this.$route.params.idAssociazione) {
        vm.loadDettagliAssociazione(this.$route.params.idAssociazione);
      } else if (this.userData.AssociazioneId) {
        vm.loadDettagliAssociazione(this.userData.AssociazioneId);
      }

      bus.$on('rinnovoUploaded', function (value) {
        if (value) {
          vm.isLoading = false;
          vm.dialogRinnovi = false;
          vm.errorDialog = false;
          setTimeout(function () {
            vm.loadDaRinnovare();
          }, 1000);
        }
      });
      bus.$on('deleteDialog', function (value) {
        if (value) {
          vm.isLoadingDelete = false;
          vm.errorDialog = false;
          vm.loadDaRinnovare();
        }
      });

      bus.$on('erroreRinnovo', function (value) {
        if (value != '') {
          vm.isLoading = false;
          vm.errorMessage = value;
          vm.errorDialog = true;
        }
      });
    },
    methods: {
      ...mapActions('associatiModule', [
        'loadAssociatiDaRinnovare',
        'loadTesseratiDaRinnovare',
        'loadAssociato',
        'loadAssociatoAsync',
        'loadAssociatoByStorico',
        'loadDettagliAssociazione',
        'loadImage',
        'loadStoricoIscrizione',
        'loadStoricoIscrizioni',
        'deleteStoricoIscrizione',
        'deleteStoricoIscrizioneAsync',
        'deleteStoricoIscrizioni',
        'deleteStoricoIscrizioniAsync',
        'stampaPassAssociati',
        'stampaPassAssociatiAsync',
        'rinnovaAssociati',
        'updateStoricoIscrizione',
        'annullaAssociati',
        'exportSagittaXLS',
        'exportAssociatiDaRinnovare',
        'exportAssociatiDuplicati',
        'uploadAssociatiDaRinnovare',
        'uploadAssociatiDaRinnovareAsync',
        'iscriviPerCorrente',
        'iscriviPerCorrenteAsync',
        'uploadTesseratiDaRinnovare',
        'uploadTesseratiDaRinnovareAsync',
      ]),
      ...mapActions('associazioniModule', ['loadAssociazioni']),
      ...mapActions('sharedModule', ['loadTipologie', 'loadAnnoRinnovo']),
      editItem(item) {
        const vm = this;
        this.loadAssociatoByStorico(item.iscrizioneId).then((a) => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.checkFormMode(false);
            bus.$emit('associatoDialog', true);
          });
        });
      },

      aggiorna() {
        this.loadDaRinnovare();
        this.isLoading = false;
      },

      dialogRinnoviOpen() {
        const vm = this;
        vm.dialogRinnovi = true;
      },

      dialogDuplicatiOpen() {
        const vm = this;
        vm.dialogDuplicati = true;
      },

      openDialogAnnullamento() {
        const vm = this;
        vm.dialogAnnullamento = true;
      },

      openDialogGtWeb() {
        const vm = this;
        vm.dialogGtWeb = true;
      },

      esportaDoppi() {
        const vm = this;
        vm.exportAssociatiDuplicati();
        vm.dialogDuplicati = false;
      },

      aggiungiIscrizione(item) {
        const vm = this;
        vm.loadDaRinnovare();
        vm.dialogModificaRinnovo = false;
        vm.iscriviPerCorrenteAsync(item.AssociatoId);
        vm.rinnovato = true;
      },

      selectRow(props) {
        const vm = this;
        if (vm.checkFunzione(vm.elencoFunzioni.STAMPA_CSAIN_PASS) || vm.checkFunzione(vm.elencoFunzioni.ACCETTA_RINNOVI_ISCRIZIONI)) {
          props.selected = !props.selected;
        }
      },
      viewItem(item) {
        const vm = this;
        this.loadAssociatoAsync(item.id).then(() => {
          this.loadImage(item.id).then(() => {
            vm.formMode = vm.formModes.VISUALIZZAZIONE;
            bus.$emit('associatoDialog', true);
          });
        });
      },
      newDialog() {
        this.formMode = this.formModes.INSERIMENTO;
        bus.$emit('associatoDialog', true);
      },

      pickFile() {
        this.$refs.fileRinnovo.click();
      },

      loadDaRinnovare() {
        if (this.tipoRinnovo === 'Tesserati') {
          this.loadTesseratiDaRinnovare();
        } else {
          this.loadAssociatiDaRinnovare();
        }
      },

      onFilePicked(e) {
        const files = e.target.files;
        if (files[0] !== undefined) {
          const fr = new FileReader();
          fr.readAsDataURL(files[0]);
          fr.addEventListener('load', () => {
            this.rinnovoObj = new FileEntity();
            this.rinnovoObj.blobFile = fr.result.replace(files[0].type + ';base64,', '');
            let uploadData = new FormData();
            uploadData.append('rinnovo', files[0], files[0].name);
            this.dialogRinnovi = false;
            this.isLoading = true;
            if (this.tipoRinnovo === 'Rinnovi') {
              this.uploadAssociatiDaRinnovareAsync({ uploadData: uploadData }).then((i) => {});
            }
            if (this.tipoRinnovo === 'Tesserati') {
              this.uploadTesseratiDaRinnovareAsync({ uploadData: uploadData }).then((i) => {});
            }

            this.$refs.fileRinnovo.value = '';
          });
        } else {
          this.rinnovoObj = new FileEntity();
        }
      },

      stampaCsainPass(idAssociazione, items) {
        const idSelected = [];
        items.forEach((element) => {
          idSelected.push(element.id);
        });
        this.stampaPassAssociatiAsync({ id: idAssociazione, data: idSelected });
        this.selected = [];
        this.dialog = false;
      },

      rinnovaIscrizioni(items) {
        const idSelected = [];
        if (this.userData.AssociazioneId) {
          items.forEach((element) => {
            idSelected.push(element.id);
          });
          this.rinnovaAssociati({ id: this.userData.AssociazioneId, data: idSelected });
        }
        this.selected = [];
      },
      accettaRinnovi(items) {
        const idSelected = [];
        if (this.userData.AssociazioneId) {
          items.forEach((element) => {
            idSelected.push(element.id);
          });
          this.rinnovaAssociati({ id: this.userData.AssociazioneId, data: idSelected });
        }

        this.selected = [];
      },
      annullaIscrizioni(items) {
        this.selected = [];
        const idSelected = [];
        items.forEach((element) => {
          idSelected.push(element.iscrizioneId);
        });
        this.deleteStoricoIscrizioniAsync(idSelected);
        this.isLoadingDelete = true;
        this.dialogAnnullamento = false;
        setTimeout(() => {
          bus.$emit('deleteDialog', true);
        }, 500);
      },
      annullaIscrizione(item) {
        const vm = this;
        vm.deleteStoricoIscrizioneAsync(item.id);
        this.dialogModificaRinnovo = false;
      },

      printAttestato(item) {
        const vm = this;
        vm.attestatoSelected = item;
        vm.dialogAttestato = true;
      },
      /* funzione richiamata dal pulsante di eliminazione dalla lista */
      eliminaSelezionato(item) {
        const vm = this;
        vm.eliminatoSelected = item;
        vm.dialogEliminato = true;
      },

      /* funziona richiamata dal tasto elimina della toolbar */
      eliminaAssociati() {
        const vm = this;
        vm.eliminatoSelected = null;
        vm.dialogEliminato = true;
      },

      /* funziona richiamata dal tasto elimina del dialog */
      elimnaAssociatiSodalizio(idAssociazione) {
        /* se provengo dal tasto sulla lista */
        if (this.eliminatoSelected) {
          this.deleteAssociato(this.eliminatoSelected);
          this.eliminatoSelected = null;
        } else {
          /* se provengo dal'elimina sulla toolbar */
          const associatiId = [];
          this.selected.forEach((i) => {
            associatiId.push(i.id);
          });
          if (associatiId.length > 0) {
            const item = {
              associazioneId: idAssociazione,
              associatiId: associatiId,
            };
            this.deleteAssociati(item);
            this.selected = [];
          }
          this.eliminatoSelected = null;
        }
        this.dialogEliminato = false;
      },

      editDatiRinnovo(item) {
        const vm = this;
        vm.rinnovato = false;
        vm.loadStoricoIscrizione({ idStorico: item.iscrizioneId, idAssociato: item.id });
        vm.dialogModificaRinnovo = true;
      },

      updateDatiRinnovo(item) {
        const vm = this;
        vm.updateStoricoIscrizione(item);
        vm.dialogModificaRinnovo = false;
      },

      downloadAttestato() {
        const vm = this;
        if (vm.attestatoSelected) {
          vm.stampaAttestato(vm.attestatoSelected.id);
        }
        vm.dialogAttestato = false;
      },

      exportRinnovi() {
        const vm = this;
        vm.exportAssociatiDaRinnovare();
        vm.dialogGtWeb = false;
      },

      exportAssociatiSagitta() {
        const vm = this;
        vm.exportSagittaXLS();
        vm.dialogSagitta = false;
      },

      resetElm() {
        this.associatoObj = new AssociatoEntity();
        this.associatoObj.Associazione = this.dettagliAssociazione;
        this.imageObj = new ImageEntity();
        this.formMode = this.formModes.VISUALIZZAZIONE;
      },
      formatDate(date) {
        return Util.formattaData(date);
      },
      checkFunzione(func) {
        return Security.isAbilitata(func, this.userData.Role);
      },
      checkFormMode(insertMode) {
        if (insertMode && Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role)) {
          return this.formModes.INSERIMENTO;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role)) {
          return this.formModes.MODIFICA;
        } else if (Security.isAbilitata(this.elencoFunzioni.VISUALIZZAZIONE_ASSOCIATO, this.userData.Role)) {
          return this.formModes.VISUALIZZAZIONE;
        }
      },
      isResponsabileAssociazione(idAssociazione) {
        let retVal = false;
        if (this.userData.AssociazioneId && idAssociazione) {
          retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
        }
        return retVal;
      },

      showDataAssociato(item) {
        if (this.userData.Role === this.ruoli.ASSOCIATO) {
          return item.canViewData;
        } else {
          return true;
        }
      },

      canModifyAssociato(idAssociato, idAssociazione) {
        let retVal = false;
        if (idAssociato) {
          if (Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId && idAssociazione) {
            retVal = Security.isAbilitata(this.elencoFunzioni.MODIFICA_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      canInsertAssociato(idAssociazione) {
        let retVal = false;
        if (this.formMode == this.formModes.INSERIMENTO) {
          if (Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO, this.userData.Role)) {
            retVal = true;
          } else if (this.userData.AssociazioneId) {
            retVal = Security.isAbilitata(this.elencoFunzioni.INSERIMENTO_ASSOCIATO_ASSOCIAZIONE, this.userData.Role) && this.userData.AssociazioneId == idAssociazione;
          }
        }
        return retVal;
      },
      customSort(items, index, isDescending) {
        const compare = new Intl.Collator('it').compare;
        if (index === null) return items;

        return items.sort((a, b) => {
          let sortA = a[index];
          let sortB = b[index];

          if (index == 'Associazione') {
            sortA = a.Associazione;
            sortB = b.Associazione;
          } else if (index == 'SezioneDescrizione') {
            sortA = a.SezioneDescrizione;
            sortB = b.SezioneDescrizione;
          } else if (index == 'CittaIndirizzo') {
            sortA = a.CittaIndirizzo;
            sortB = b.CittaIndirizzo;
          }

          if (isDescending) {
            [sortA, sortB] = [sortB, sortA];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          [sortA, sortB] = [sortA, sortB].map((s) => {
            return (s || '').toString();
          });

          return compare(sortA, sortB);
        });
      },
    },
  };
</script>
